import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Heart, Users } from "lucide-react";
import ProgressBar from "./ProgressBar";
import { formatBRL } from "@/lib/api";

export default function CampaignCard({ campaign, index = 0 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.5, delay: (index % 3) * 0.08 }}
      whileHover={{ y: -6 }}
      className="h-full"
    >
      <Link
        to={`/vaquinha/${campaign.slug}`}
        data-testid="campaign-card-item"
        className="flex h-full flex-col overflow-hidden rounded-2xl border border-[#EFE9DF] bg-white shadow-sm transition-shadow hover:shadow-xl hover:shadow-[#FF6D47]/10"
      >
        <div className="relative h-44 overflow-hidden">
          <img
            src={campaign.cover}
            alt={campaign.title}
            className="h-full w-full object-cover transition-transform duration-500 hover:scale-105"
            loading="lazy"
          />
          <span className="absolute left-3 top-3 rounded-full bg-white/95 px-3 py-1 text-[11px] font-extrabold uppercase tracking-wide text-[#FF6D47] shadow">
            {campaign.category}
          </span>
        </div>
        <div className="flex flex-1 flex-col gap-3 p-5">
          <h3 className="font-display line-clamp-2 text-lg font-bold leading-snug text-[#261C14]">{campaign.title}</h3>
          <div className="mt-auto space-y-2">
            <ProgressBar pct={campaign.progress} />
            <p className="text-sm font-bold text-[#261C14]">
              {formatBRL(campaign.raised_cents)}{" "}
              <span className="font-normal text-[#9E9085]">arrecadados de {formatBRL(campaign.goal_cents)}</span>
            </p>
            <div className="flex items-center gap-4 text-xs font-bold text-[#6E6259]">
              <span className="flex items-center gap-1">
                <Heart className="h-3.5 w-3.5 fill-[#E11D48] text-[#E11D48]" /> {campaign.hearts}
              </span>
              <span className="flex items-center gap-1">
                <Users className="h-3.5 w-3.5" /> {campaign.supporters} apoiadores
              </span>
            </div>
          </div>
        </div>
      </Link>
    </motion.div>
  );
}
